import { createFileRoute } from "@tanstack/react-router";
import { seo } from "@/lib/seo";
import About from "@/pages/About";

export const Route = createFileRoute("/_site/about")({
  head: () => ({
    ...seo({
      title: "Our Team | Kodiak Structures & Exteriors - Roofing Experts",
      description:
        "Meet the crew behind Kodiak Structures & Exteriors. Expert roofing, siding, and exterior services throughout Minnesota.",
      path: "/about",
    }),
  }),
  component: About,
});
